// ** Inital state
const initialState = {
  streamerVersion: "",
  streamerFileName: null,
  userInactivityTime: 10 * 60 * 1000, //* 10 minutes
  langEditMode: false,
  langModalOpen: false,
  routeTracking: {},
  languageKey: "ru",
  languageWords: {},
  languageList: []
}

const config = (state = initialState, action) => {
  switch (action.type) {
    case "STREAMER_VERSION":
      return { ...state, streamerVersion: action.val }
    case "STREAMER_FILE_NAME":
      return { ...state, streamerFileName: action.val }
    case "HANDLE_USER_INACTIVITY":
      return { ...state, userInactivityTime: action.val }
    case "LANGUAGE_EDIT_MODE":
      return { ...state, langEditMode: action.val }
    case "LANGUAGE_MODAL_OPEN":
      return { ...state, langModalOpen: action.val }
    case "ROUTE_TRACKING":
      return { ...state, routeTracking: action.val }
    case "LANGUAGE_KEY":
      return { ...state, languageKey: action.val }
    case "LANGUAGE_WORDS":
      return { ...state, languageWords: action.val }
    case "LANGUAGE_LIST":
      return { ...state, languageList: action.val }
    default:
      return state
  }
}
export default config
